import { render, staticRenderFns } from "./UnarchivePlan.vue?vue&type=template&id=66485052&scoped=true"
import script from "./UnarchivePlan.vue?vue&type=script&lang=js"
export * from "./UnarchivePlan.vue?vue&type=script&lang=js"
import style0 from "./UnarchivePlan.vue?vue&type=style&index=0&id=66485052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66485052",
  null
  
)

export default component.exports